import React, { useEffect, useRef, useState } from 'react'
import { IconButton, Grid } from '@material-ui/core'
import NavigateNext from '@material-ui/icons/NavigateNext'
import NavigateBefore from '@material-ui/icons/NavigateBefore'
import useResizeObserver from 'Hooks/useResizeObserver/useResizeObserver'
import { TaxExemptionStatus } from 'TypeDefs/TaxExemptionStatusTracker'
import useStyles from './styles'
import statusList from './statusList'
import StatusTrackerTile from '../StatusTrackerTile/StatusTrackerTile'

type Props = {
  currentStatus: TaxExemptionStatus
}
const StatusTracker = ({ currentStatus }: Props) => {
  const [positionOnLoad] = statusList.filter(
    (status) => status.key === currentStatus
  )
  const containerRef = useRef<any>(null)
  const sizes = useResizeObserver(containerRef)
  const [disablePrev, setDisablePrev] = useState(true)
  const [disableNext, setDisableNext] = useState(false)
  const [scrollBarPos, setScrollBarPos] = useState(positionOnLoad.step)
  const itemWidth = Math.ceil(
    containerRef.current?.scrollWidth / statusList.length
  )

  const getClickHandler = (direction: string) => {
    const onClickHandler = () => {
      const newScrollBarPos =
        direction === 'next'
          ? scrollBarPos + itemWidth
          : scrollBarPos - itemWidth
      containerRef.current.scrollTo({
        top: 0,
        left: newScrollBarPos,
        behavior: 'smooth',
      })
      setScrollBarPos(newScrollBarPos)
    }
    return onClickHandler
  }

  useEffect(() => {
    const scrollWidth = containerRef.current?.scrollWidth
    if (scrollBarPos + sizes.width >= scrollWidth) {
      setDisableNext(true)
    }
    if (scrollBarPos + sizes.width < scrollWidth) {
      setDisableNext(false)
    }
    if (scrollBarPos < itemWidth) {
      setDisablePrev(true)
    }
    if (scrollBarPos >= itemWidth) {
      setDisablePrev(false)
    }
  }, [containerRef, sizes, scrollBarPos, itemWidth])

  const classes = useStyles()

  return (
    <>
      <IconButton
        className={classes.iconButtonPrevious}
        aria-label='previous'
        disableFocusRipple
        disableRipple
        onClick={getClickHandler('prev')}
        disabled={disablePrev}
      >
        <NavigateBefore />
      </IconButton>
      <div ref={containerRef} className={classes.statusContainer}>
        {statusList.map((status, idx) => (
          <Grid key={status.key} item className={classes.flexItem}>
            <StatusTrackerTile
              key={status.key}
              title={status.title}
              Icon={status.icon}
              completed={
                positionOnLoad.step > idx ||
                positionOnLoad.step === statusList.length - 1
              }
              featured={currentStatus === status.key}
            />
          </Grid>
        ))}
      </div>
      <IconButton
        onClick={getClickHandler('next')}
        className={classes.iconButtonNext}
        aria-label='next'
        disableFocusRipple
        disableRipple
        disabled={disableNext}
        name='next'
      >
        <NavigateNext />
      </IconButton>
    </>
  )
}

export default StatusTracker
